export default __webpack_public_path__ + "static/media/esg-img.c2e819eb.jpg";